export const GCF_URL_BASE = 'https://us-central1-tlm2021-41ce7.cloudfunctions.net';
